import { useState } from 'react'
import { Button, Hint, Modal } from '@rammetec/design-system'
import { TriangleAlert } from 'lucide-react'
import { useCurrentOrganizationData } from '@syscolect/application'

/**
 * Header warning indicator when the current organization has a `warning` message.
 * Tooltip on hover; click opens a dialog with the full text (legacy DashboardAppBar behavior).
 */
export function OrganizationWarningButton() {
  const { organizationData } = useCurrentOrganizationData()
  const [open, setOpen] = useState(false)
  const warning = organizationData?.warning?.trim()

  if (!warning) return null

  return (
    <>
      <Hint label={warning} side="bottom">
        <Button
          variant="ghost"
          size="icon"
          aria-label="Aviso da organização"
          className="text-amber-600 hover:bg-amber-500/10 hover:text-amber-600 dark:text-amber-500 dark:hover:text-amber-500"
          onClick={() => setOpen(true)}
        >
          <TriangleAlert />
        </Button>
      </Hint>

      <Modal
        name="console.organization-warning"
        open={open}
        onOpenChange={setOpen}
        title="Aviso da organização"
        size="sm"
        footer={
          <Button onClick={() => setOpen(false)}>OK</Button>
        }
      >
        <p className="whitespace-pre-wrap text-sm">{warning}</p>
      </Modal>
    </>
  )
}
